export default __webpack_public_path__ + "static/media/node.3cefb87c.svg";